import { useEffect, useState } from 'react';
import { userEvaluationUserList } from 'Api/courseDetailsEvaluations';

const useFetch = ({ courseId, lessonId }, setIsLoading) => {
  const [employees, setEmployees] = useState([]);
  const [unpublishedGrades, setUnpublishedGrades] = useState([]);
  const [errors, setErrors] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [terminals, setTerminals] = useState([]);
  const [jobTitles, setJobTitles] = useState([]);

  useEffect(() => {
    userEvaluationUserList({ lessonId, courseId }).then(data => {
      setEmployees(data.users);
      setUnpublishedGrades(data.users.map(user => user[9]));
      setErrors(data.users.map(user => null));
      setDepartments(data.departments);
      setTerminals(data.terminals);
      setJobTitles(data.jobTitles);
      setIsLoading(false);
    });
  }, [lessonId, courseId]);

  return {
    employees,
    setEmployees,
    unpublishedGrades,
    setUnpublishedGrades,
    departments,
    terminals,
    jobTitles,
    errors,
    setErrors,
  };
};

export default useFetch;
